export default {
    API: window.location.href.indexOf('localhost') > 0 ? 'http://localhost:8081/' : '/server/'
}